<script setup async>
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { AUTH_URL } from '@/common/config'
import {onMounted} from 'vue'

const router = useRouter()
const route = useRoute()
const store = useStore()

if (typeof route.query.logout != 'undefined') {
  window.location.href = AUTH_URL + '?redirect=/'
}

onMounted(async () => {
  await router.isReady()
  if(window.localStorage.getItem('LK_ID') === null) {
    await router.push({name: 'ErrorPage', query: {code: '403', message: 'Не указан LKID'}})
    return
  }
  if (store.getters.isAuthenticated) {
    await router.push({name: "BudgetDraft"});
  }
})

</script>
<template>
  <div>

  </div>
</template>
